import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import AnnualBenefitForm, {
  AnnualBenefitFormRef,
  AnnualBenefitFormValues,
} from './AnnualBenefitForm';

type EditAnnualBenefitProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: AnnualBenefitFormValues) => Promise<void>;
  data: IBIK;
};

const EditAnnualBenefitModal: React.FC<EditAnnualBenefitProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditAnnualBenefitProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<AnnualBenefitFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: AnnualBenefitFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editAnnualBenefit']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <AnnualBenefitForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          startDate: data.startDate ? moment(data.startDate) : null,
          description: data.description,
          endDate: data.endDate ? moment(data.endDate) : null,
          eeContribution: data.eeContribution?.toString(),
          totalEeContribution: data.totalEeContribution?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditAnnualBenefitModal;
